import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { stockReservationTypes, listUserGroups } from "@/js/lists.ts";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import { formRules } from "@/js/form_rules.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "StockReservation",
  props: {
    form: Object,
    isPrefixedWithDefault: Boolean,
    reservedForMessage: String,
    userListPreLoaded: Array,
    consultantListPreLoaded: Array,
    typesIdExcluded: Array,
    isForStockTransfer: Boolean,
    readonly: Boolean
  },
  components: {
    ErrorModal: ErrorModal
  },
  data: function data(_this) {
    return {
      valid: false,
      gettingUserList: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      gettingConsultantList: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      formRules: formRules,
      stockReservationTypes: stockReservationTypes,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    availableStockReservationTypes: function availableStockReservationTypes() {
      var _this$typesIdExcluded,
        _this2 = this;
      if (((_this$typesIdExcluded = this.typesIdExcluded) === null || _this$typesIdExcluded === void 0 ? void 0 : _this$typesIdExcluded.length) > 0) {
        return Object.values(this.stockReservationTypes).filter(function (x) {
          return !_this2.typesIdExcluded.includes(x.id);
        });
      } else {
        return Object.values(this.stockReservationTypes).map(function (x) {
          return _objectSpread(_objectSpread({}, x), {}, {
            name: _this2.isForStockTransfer && x.id == stockReservationTypes.DEFAULT.id ? "Default reservation of destination warehouse" : x.name
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this3$userListPreLoa, _this3$consultantList;
      var promises;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            promises = [];
            if (!((_this3$userListPreLoa = _this3.userListPreLoaded) !== null && _this3$userListPreLoa !== void 0 && _this3$userListPreLoa.length) > 0) {
              promises.push(_this3.fetchUserList());
            }
            if (!((_this3$consultantList = _this3.consultantListPreLoaded) !== null && _this3$consultantList !== void 0 && _this3$consultantList.length) > 0) {
              promises.push(_this3.fetchConsultantList());
            }
            if (promises.length > 0) {
              Promise.all(promises).then(function () {
                _this3.$emit("mounted");
              });
            } else {
              _this3.$emit("mounted");
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    updateData: function updateData() {
      this.$emit("change", this.form);
    },
    fetchUserList: function fetchUserList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$gettingUserLis;
        var _this, response, values;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.gettingUserList.results = [];
              _this4.gettingUserList.isPending = true;
              (_this4$gettingUserLis = _this4.gettingUserList.cancellationToken) === null || _this4$gettingUserLis === void 0 || _this4$gettingUserLis.cancel();
              _this4.gettingUserList.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context2.next = 7;
              return request("/v1/third-party-users", "get", {}, true, "api", null, _this.gettingUserList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available users for reservation", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context2.sent;
              values = _toConsumableArray(response.data.value);
              values.forEach(function (user) {
                var _listUserGroups$find;
                var fullName = getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")";
                _this4.gettingUserList.results.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this4.gettingUserList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this4.$emit("stockReservationUserListLoaded", _this4.gettingUserList.results);
              _this4.gettingUserList.isPending = false;
              return _context2.abrupt("return", Promise.resolve());
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchConsultantList: function fetchConsultantList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$gettingConsult;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.gettingConsultantList.results = [];
              _this5.gettingConsultantList.isPending = true;
              (_this5$gettingConsult = _this5.gettingConsultantList.cancellationToken) === null || _this5$gettingConsult === void 0 || _this5$gettingConsult.cancel();
              _this5.gettingConsultantList.cancellationToken = axios.CancelToken.source();
              data = {
                isHolding: true,
                active: true
              };
              _this = _this5;
              _context3.next = 8;
              return request("/v1/users", "post", data, true, "api", null, _this.gettingConsultantList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available consultants for reservation", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context3.sent;
              response.data.users.forEach(function (user) {
                _this5.gettingConsultantList.results.push({
                  id: user.id_user,
                  full_name: getFullNameUser(user) + " - " + user.delivery_country_iso_code + " - " + user.consultant_code + " (" + user.login + ")"
                });
              });
              _this5.gettingConsultantList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this5.$emit("stockReservationConsultantListLoaded", _this5.gettingConsultantList.results);
              _this5.gettingConsultantList.isPending = false;
              return _context3.abrupt("return", Promise.resolve());
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};